// extracted by mini-css-extract-plugin
export default {"main":"WidgetAdd_main__7sARx","text":"WidgetAdd_text__yqi97"};